import { getWishlistFromCookie } from "../libraries/WishlistLibrary.mjs";
import { z } from "../libraries/zod.js";
import { closeAllModals, openModal } from "./base/modals.js";
import { getCaptchaV3Token } from "./captcha.js";
import {
  codeMenuFunctionary,
  openHeaderMenu,
  subheadingFixed,
} from "./header/headerMenus.js";
import { shopsData } from "./pages/order/cityMap.js";
import { createAddressLabel } from "./pages/order/createAddressLabel.js";
import { dispatchOrderValidate } from "./pages/order/orderValidation.js";
import { handleBankCardSubmit } from "./pages/profile/addBankCard.js";
import {
  formatDate,
  getCurrentQuery,
  getFile,
  sendData,
  setCookie,
  userLoggedIn,
  debounce,
} from "./utils.js";

function getTextInsideSquareBrackets(text) {
  const startIndex = text.indexOf("["); // Находим индекс первой открывающей скобки
  const endIndex = text.lastIndexOf("]"); // Находим индекс последней закрывающей скобки
  if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
    // Проверяем, что скобки найдены и первая скобка находится перед последней
    return text.substring(startIndex + 1, endIndex); // Возвращаем текст между первой и последней скобками
  } else {
    return ""; // Если скобки не найдены или первая скобка находится после последней, возвращаем пустую строку
  }
}

const schemaRegister = z
  .object({
    email: z.string().email({ message: "Invalid email address" }),
    password: z.string().min(4, { message: "слишком коротко" }),
    repeat_password: z.string().min(4, { message: "слишком коротко" }),
  })
  .refine((data) => data.password === data.repeat_password, {
    message: "Passwords don't match",
    path: ["password", "repeat_password"], // path of error
  });
const schemaNewPass = z
  .object({
    password: z.string().min(4, { message: "слишком коротко" }),
    repeat_password: z.string().min(4, { message: "слишком коротко" }),
  })
  .refine((data) => data.password === data.repeat_password, {
    message: "Passwords don't match",
    path: ["password", "repeat_password"], // path of error
  });
const schemaLogin = z.object({
  phone: z.string().min(18, { message: "Неверное количество символов" }),
  ref_code: z.string(),
});
const schemaCallBack = z.object({
  // email: z.string()
  //     .email({ message: "Invalid email address" }),
  phone: z.string().min(18),
  first_name: z.string().min(1),
  // last_name: z.string(),
  message: z.string(),
});
const schemaHelp = z.object({
  phone: z.string().min(18),
  first_name: z.string().min(1),
  email: z.string().email(),
  city: z.string().min(1),
});
const schemaReview = z.object({
  name: z.string().min(1),
  phone: z.string().min(18),
  message: z.string().min(1),
});
const schemaCode = z.object({
  code: z.string().min(4).max(4),
  phone: z.string().min(18),
  ref_code: z.string(),
});
const schemaUserInfo = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  phone: z.string().min(18),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
});
const schemaAddUserInfo = z.object({
  email: z
    .string()
    .email({ message: "Введите Вашу почту" })
    .optional()
    .or(z.literal("")),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
});
const schemaAddress = z.object({
  city: z.string().min(1),
  street: z.string(),
  // apartment: z.string(),
  house: z.string().min(1),
});
// Кастомная проверка: город валиден, если выбран из подсказки (dataset.cityValid === 'true')
// или совпадает с городами, пришедшими из нашего API (/api/cities/)
const wholesalersSchema = z.object({
  phone: z.string().min(18),
  first_name: z.string().min(1),
  city: z.string().min(1, { message: "Укажите город" })
});
const distributionSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});
const getMoneySchema = z.object({
  phone: z.string().min(18),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
});
const orderSchema = z.object({
  phone: z.string().min(18),
  email: z.string().email({ message: "Invalid email address" }),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
});
const promocodeSchema = z.object({
  promo_code: z.string().min(1)
});
const vacancySchema = z.object({
  // city: z.string(),
  name: z.string().min(1),
  phone: z.string().min(18),
  birthday: z.string(),
  citizenship: z.string(),
});
const refundSchema = z.object({
  comment: z.string().min(1),
});
const addCardSchema = z.object({
  pan: z.string().min(19),
  exp_date: z.string().min(5),
  // card_holder: z.string(),
  cvv: z.string().min(3),
});

export function validation() {
  // Инициализируем автодополнение городов на основе API shops
  setCityDelivery();
  
  const loginForm = document.querySelector("#login-menu-form");
  if (loginForm) {
    formValidate(loginForm, schemaLogin, async (body) => {
      const codeFormPhone = document.querySelector("#code-form-login-phone");
      const codeFormReferral = document.querySelector("#code-form-login-referral");
      loginForm.button.setAttribute("disabled", "disabled");
      try {
        const token = await getCaptchaV3Token();
				
        const bodyWithCaptcha = token ? { ...body, g_recaptcha_response: token } : body;
        const res = await sendData(bodyWithCaptcha, "/api/authentication/get-code/");
        if (res.error) {
          dialogAnimate("error", res.error);
        } else if (res.detail) {
          dialogAnimate("error", "Вы привысили кол-во попыток, попробуйте позже");
        } else if (res.message) {
          codeFormPhone.value = body.phone;
          codeFormReferral.value = body.ref_code;
          codeFormPhone.focus();
          clearForm(loginForm);
          openHeaderMenu("code-login");
          subheadingFixed();
        }
      } catch (e) {
        dialogAnimate("error", "Произошла ошибка, попробуйте позже");
      }
    });
  }
  const codeForm = document.querySelector("#code-login-form");
  if (codeForm) {
    formValidate(codeForm, schemaCode, (body) => {
      const codeMenuInput = document.querySelector("#code-menu-login-input");
      const params = new URLSearchParams(window.location.search);
      body.fcm = localStorage.getItem('fcm_token')
      body.platform = localStorage.getItem('platform')
      sendData(body, "/api/authentication/confirm-code/").then((res) => {
        if (res.error) {
          codeMenuInput.classList.add("error");
          codeForm.elements.button.disabled = true;
          dialogAnimate("error", res.error);
        } else {
          const wishlist = getWishlistFromCookie();
          setCookie("expire_date", res.expire_date);
          setCookie("access_token", res.access_token);
          setCookie("refresh_token", res.refresh_token);
          const wishlistPromises = wishlist.map((item) => {
            sendData(item, "/api/wishlist/add/");
          });
          Promise.all(wishlistPromises).then((result) => {
            setCookie("wishlist", "", { "max-age": -1 });
          });
          const NextPage = getCurrentQuery().find((item) => item.next)?.next;

          if (NextPage) {
            window.location.href = NextPage;
          } else {
            window.location.href = "/profile/";
          }
        }
      });
    });
  }
  const codeFormInOrder = document.querySelector("#confirm-phone-in-order");
  if (codeFormInOrder) {
    formValidate(codeForm, schemaCode, (body) => {
      const codeMenuInput = document.querySelector("#code-menu-login-input");
      sendData(body, "/api/authentication/confirm-code/").then((res) => {
        if (res.error) {
          codeForm.elements.button.disabled = true;
          dialogAnimate("error", 'Не верный код!');
        } else {
          dialogAnimate("success-auth", 'Вы авторизированны!');
          document.querySelector('#order-form').dataset.auth = "1"
          document.getElementById('confirm-phone-in-order').style.display = 'none'
        }
      }).catch((err) => {
          codeForm.elements.button.disabled = true;
          dialogAnimate("error", 'Не верный код!');
      })
    });
  }
  const reviewForm = document.querySelector("#review-form");
  if (reviewForm) {
    formValidate(reviewForm, schemaReview, (body) => {
      const info = {
        ...body,
      };
      const ratingValue = document.querySelector(
        '[name="review-modal-selector"]:checked'
      );
      if (ratingValue) info.rating = parseInt(ratingValue.dataset.value);
      sendData(info, "/api/reviews/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.href = "/success/?scenario=review";
        }
      });
    });
  }
  const helpForm = document.querySelector("#help-form");
  if (helpForm) {
    formValidate(helpForm, schemaHelp, (body) => {
      sendData(body, "/api/feedback/faq/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.href = "/success/";
        }
      });
    });
  }
  const updUserInfoForm = document.querySelector("#change-user-info");
  if (updUserInfoForm) {
    formValidate(updUserInfoForm, schemaUserInfo, (body) => {
      const info = {
        ...body,
      };
      const gender = document.querySelector('[name="select-sex"]:checked');
      const birthdayInput = updUserInfoForm.querySelector('[name="birthday"]');
      if (!!gender) info["gender"] = gender.dataset.gender;
      if (birthdayInput.value == "") {
        info.birthday = null;
      } else {
        info.birthday = formatDate(birthdayInput.value);
      }

      const cityInput = updUserInfoForm.querySelector('[name="city"]');
      if (cityInput.dataset.attr !== "")
        info.city = parseInt(
          cityInput.closest(".__select__title").dataset.attr
        );

      sendData(info, "/api/profile/update/", "PATCH")
        .then((res) => {
          if (res.error) {
            dialogAnimate("error", res.error);
          } else {
            dialogAnimate("upd_user_info_dialog");
            updUserInfoForm.elements.button.disabled = true;
            updUserInfoForm.dataset.state = "disabled";
            setTimeout(() => {
              updUserInfoForm.dataset.state = null;
            }, 5000);
          }
        })
        .catch((err) => {
          if (err) {
            let errMessage = "Произошла ошибка";
            if (err.data.detail) {
              errMessage = err.data.detail;
            } else if (err.data.error) {
              errMessage = err.data.error;
            } else {
              console.log(err.data);
            }
            dialogAnimate("error", errMessage);
          }
        });

      if (
        updUserInfoForm.dataset.changePhone &&
        updUserInfoForm.dataset.changePhone == "true"
      ) {
        sendData(
          { phone: body.phone },
          "/api/profile-phone/request-update-number/"
        )
          .then((res) => {
            if (error) {
              dialogAnimate("error", res.error);
            } else {
              const phoneInput = document.querySelector(
                "#code-form-change-phone-phone"
              );
              phoneInput.value = body.phone;
              openModal("change-phone");
              codeMenuFunctionary(
                "change-phone",
                "/api/profile-phone/request-update-number/"
              );
            }
          })
          .catch((err) => {
            dialogAnimate("error", Object.values(err.data)[0][0]);
          });
      }
    });
  }
  const addUserInfoForm = document.querySelector("#update-user-data-form");
  if (addUserInfoForm) {
    formValidate(addUserInfoForm, schemaAddUserInfo, (body) => {
      const info = {
        ...body,
      };
      const birthdayInput = addUserInfoForm.querySelector('[name="birthday"]');
      if (birthdayInput.value == "") {
        info.birthday = null;
      } else {
        info.birthday = formatDate(birthdayInput.value);
      }

      const cityInput = addUserInfoForm.querySelector('[name="city"]');
      if (cityInput.dataset.attr !== "")
        info.city = parseInt(
          cityInput.closest(".__select__title").dataset.attr
        );

      sendData(info, "/api/profile/update/", "PATCH")
        .then((res) => {
          if (res.error) {
            dialogAnimate("error", res.error);
          } else {
            setCookie("needGetFullInfo", "false");
            const NextPage = getCurrentQuery().find((item) => item.next)?.next;
            if (NextPage) {
              window.location.href = NextPage;
            } else {
              window.location.href = "/profile/";
            }
          }
        })
        .catch((err) => {
          if (err) {
            let errMessage = "Произошла ошибка";
            if (err.data.detail) {
              errMessage = err.data.detail;
            } else if (err.data.error) {
              errMessage = err.data.error;
            } else {
              console.log(err.data);
            }
            dialogAnimate("error", errMessage);
          }
        });

      if (
        addUserInfoForm.dataset.changePhone &&
        addUserInfoForm.dataset.changePhone == "true"
      ) {
        sendData(
          { phone: body.phone },
          "/api/profile-phone/request-update-number/"
        )
          .then((res) => {
            if (error) {
              dialogAnimate("error", res.error);
            } else {
              const phoneInput = document.querySelector(
                "#code-form-change-phone-phone"
              );
              phoneInput.value = body.phone;
              openModal("change-phone");
              codeMenuFunctionary(
                "change-phone",
                "/api/profile-phone/request-update-number/"
              );
            }
          })
          .catch((err) => {
            dialogAnimate("error", Object.values(err.data)[0][0]);
          });
      }
    });
  }
  const changePhoneModalForm = document.querySelector(
    "#code-change-phone-modal-form"
  );
  if (changePhoneModalForm) {
    formValidate(changePhoneModalForm, schemaCode, (body) => {
      sendData(body, "/api/profile-phone/confirm-update-number/").then(
        (res) => {
          if (res.error) {
            dialogAnimate("error", res.error);
          } else {
            window.location.reload();
          }
        }
      );
    });
  }
  const newAddressForm = document.querySelector("#add-new-address-form");
  if (newAddressForm) {
    formValidate(newAddressForm, schemaAddress, (body) => {
      const apartmentValue = newAddressForm.elements.apartment.value;
      const privateHouse = newAddressForm
        .closest(".modal")
        .querySelector('[name="private-house"]').checked;

      if (!privateHouse) body.apartment = apartmentValue;

      body.street = newAddressForm.elements.street.value;
      body.city = newAddressForm.elements.city.value;

      const house = body.house == "" ? "" : `, д.${body.house}`;
      const apartment = apartmentValue == "" ? "" : `, кв.${apartmentValue}`;

      body.address = `${body.city}, ${body.street}${house}${apartment}`;

      sendData(body, "/api/profile-address/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.reload();
        }
      });
    });
  }
  const newAddressFormMap = document.querySelector("#add-new-address-form-map");
  if (newAddressFormMap) {
    formValidate(newAddressFormMap, schemaAddress, (body) => {
      const apartmentValue = newAddressForm.elements.apartment.value;
      const privateHouse = newAddressForm
        .closest(".modal")
        .querySelector('[name="private-house"]').checked;

      if (!privateHouse) body.apartment = apartmentValue;

      body.street = newAddressForm.elements.street.value;
      body.city = newAddressForm.elements.city.value;

      const house = body.house == "" ? "" : `, д.${body.house}`;
      const apartment = apartmentValue == "" ? "" : `, кв.${apartmentValue}`;

      body.address = `${body.city}, ${body.street}${house}${apartment}`;

      sendData(body, "/api/profile-address/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.reload();
        }
      });
    });
  }
  const wholesalersForm = document.querySelector("#wholesalers-form");
  if (wholesalersForm) {
    formValidate(wholesalersForm, wholesalersSchema, (body) => {
      const volumeInput = wholesalersForm.querySelector(".__counter__input");
      body.message = volumeInput.value;

      // body.phone = body.phone_num
      // body.first_name = body.name
      
      sendData(body, "/api/feedback/old-fabric/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          dialogAnimate("help-form");
          clearForm(wholesalersForm);
          volumeInput.value = "0кг";
        }
      });
    });
  }
  const distributionForm = document.querySelector("#distribution-form");
  if (distributionForm) {
    formValidate(distributionForm, distributionSchema, (body) => {
      sendData(body, "/api/mailing/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          clearForm(distributionForm);
        }
      });
    });
  }
  const getMoneyForm = document.querySelector("#get-money-form");
  if (getMoneyForm) {
    formValidate(getMoneyForm, getMoneySchema, (body) => {
      const codeFormPhone = document.querySelector("#code-form-money-phone");
      const select = getMoneyForm.querySelector(".__select_where_from");
      if (select) body.source = select.dataset.attr;

      const cityInput = getMoneyForm.querySelector('[name="city"]');
      const cityTitle = cityInput.closest(".__select__title");
      if (cityTitle.dataset.attr !== "")
        body.city = parseInt(cityTitle.dataset.attr);

      sendData(body, "/api/promocode/get-code/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else if (res.detail) {
          dialogAnimate(
            "error",
            "Вы привысили кол-во попыток, попробуйте позже"
          );
        } else {
          codeFormPhone.value = body.phone;
          codeFormPhone.focus();
          clearForm(getMoneyForm);
          openHeaderMenu("code-money");
          subheadingFixed();
        }
      });
    });
  }
  const confirmMoneyForm = document.querySelector("#code-money-form");
  if (confirmMoneyForm) {
    formValidate(confirmMoneyForm, schemaCode, (body) => {
      sendData(body, "/api/promocode/confirm-code/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.href = "/success/?scenario=coupon";
        }
      });
    });
  }
  const newAddressFormOrder = document.querySelector(
    "#add-new-address-form-order"
  );
  const newAddressFormMapOrder = document.querySelector(
    "#add-new-address-form-map-order"
  );
  if (newAddressFormOrder) {
    formValidate(newAddressFormOrder, schemaAddress, (body) => {
      const apartmentValue = newAddressFormOrder.elements.apartment.value;
      const privateHouse = newAddressFormOrder
        .closest(".modal")
        .querySelector('[name="private-house"]').checked;

      if (!privateHouse) body.apartment = apartmentValue;

      const addressOrderList = document.querySelector(".__address_order__list");
      body.street = newAddressFormOrder.elements.street.value;
      body.city = newAddressFormOrder.elements.city.value;

      const house = body.house == "" ? "" : `, д.${body.house}`;
      const apartment = apartmentValue == "" ? "" : `, кв.${apartmentValue}`;

      body.address = `${body.city}, ${body.street}${house}${apartment}`;

      if (window.savePersonalAddress) {
        const addressData = {
          city: body.city,
          street: body.street,
          house: body.house,
          apartment: body.apartment || '',
          isPrivateHouse: privateHouse,
          fullAddress: body.address
        };
        const success = window.savePersonalAddress(addressData);
        // console.log('✅ Адрес сохранен в localStorage:', addressData);
        
        if (success && window.updatePersonalAddressesDropdown) {
          window.updatePersonalAddressesDropdown();
          
          if (window.setPersonalAddressToForm) {
            window.setPersonalAddressToForm(addressData);
          }
          
          if (window.calculateOrderPrice) {
            window.calculateOrderPrice(addressData.city, '136');
          }
          
          if (window.dispatchOrderValidate) {
            window.dispatchOrderValidate();
          }
          
          if (window.updateCdekDropdown) {
            window.updateCdekDropdown();
          }
        }
      }

      clearAddressFormPreserveCity(newAddressFormOrder);
      clearAddressFormPreserveCity(newAddressFormMapOrder);
      createAddressLabel(addressOrderList, body.address, body.city);
      closeAllModals();
      dispatchOrderValidate();
      console.log(body);
      if (userLoggedIn()) sendData(body, "/api/profile-address/");
    });
  }
  if (newAddressFormMapOrder) {
    formValidate(newAddressFormMapOrder, schemaAddress, (body) => {
      const apartmentValue = newAddressFormOrder.elements.apartment.value;
      const privateHouse = newAddressFormOrder.elements.privateHouse.checked;

      if (!privateHouse) body.apartment = apartmentValue;

      const addressOrderList = document.querySelector(".__address_order__list");
      body.street = newAddressFormOrder.elements.street.value;
      body.city = newAddressFormOrder.elements.city.value;

      const house = body.house == "" ? "" : `, д.${body.house}`;
      const apartment = apartmentValue == "" ? "" : `, кв.${apartmentValue}`;

      body.address = `${body.city}, ${body.street}${house}${apartment}`;

      // Сохраняем адрес в localStorage для личных адресов
      if (window.savePersonalAddress) {
        const addressData = {
          city: body.city,
          street: body.street,
          house: body.house,
          apartment: body.apartment || '',
          isPrivateHouse: privateHouse,
          fullAddress: body.address
        };
        const success = window.savePersonalAddress(addressData);
        console.log('✅ Адрес сохранен в localStorage (карта):', addressData);
        
        // Обновляем dropdown и подставляем адрес
        if (success && window.updatePersonalAddressesDropdown) {
          window.updatePersonalAddressesDropdown();
          
          // Подставляем адрес в форму заказа
          if (window.setPersonalAddressToForm) {
            window.setPersonalAddressToForm(addressData);
          }
          
          // Обновляем расчет цены и валидацию
          if (window.calculateOrderPrice) {
            window.calculateOrderPrice(addressData.city, '136');
          }
          
          if (window.dispatchOrderValidate) {
            window.dispatchOrderValidate();
          }
          
          // Обновляем dropdown CDEK при сохранении адреса
          if (window.updateCdekDropdown) {
            window.updateCdekDropdown();
          }
        }
      }

      clearAddressFormPreserveCity(newAddressFormOrder);
      clearAddressFormPreserveCity(newAddressFormMapOrder);
      createAddressLabel(addressOrderList, body.address, body.city);
      closeAllModals();
      dispatchOrderValidate();
      if (userLoggedIn()) sendData(body, "/api/profile-address/");
    });
  }
  const orderForm = document.querySelector("#order-form");
  if (orderForm) {
    formValidate(orderForm, orderSchema, (body) => {
      console.log('valid email');

      const queries = getCurrentQuery();

      const saveInProfile = document.querySelector("#save-in-profile-checkbox");
      if (userLoggedIn() && saveInProfile && saveInProfile.checked) {
        body["save_in_profile"] = saveInProfile.checked;
      }

      let idQuery = null;
      if (queries.length > 0) {
        idQuery = getCurrentQuery()[0].order_id;
      }
      if (!!orderForm.dataset.city_name)
        body.city = orderForm.dataset.city_name;
      if (!!orderForm.dataset.address) body.address = orderForm.dataset.address;
      if (!!orderForm.dataset.cdek_order)
        body.cdek_order = { shipment_point: orderForm.dataset.cdek_order };
      if (!!orderForm.dataset.bonus_amount)
        body.bonus_amount = orderForm.dataset.bonus_amount;
      const promocodeInput = document.querySelector('#order-section-promocode');
      // # 1
      if(!!promocodeInput.value && !promocodeInput.classList.contains('error')) {
        body.promo_code = promocodeInput.value;
      }
      // # 1
      // if (document.querySelector('#order-form').dataset.auth) {
        sendData(body, `/api/order/${idQuery}/`, "PATCH")
        .then((res) => {
          const productCards = document.querySelectorAll(".product-card-order");
          try {
            sessionStorage.removeItem('cdek_selected_addresses');
            sessionStorage.removeItem('personal_delivery_addresses');
          } catch (e) {}
          window.location = res.redirect_url;
        })
        .catch((error) => {
          // const data = error.data["error"] || error.data["detail"];
          console.error(error);
          dialogAnimate("error", 'Произошла ошибка...');
        });
      // } 
      // else {
      //   confirmPhone()
      // }
    });
  }
  // # 1
  const promocodeForm = document.querySelector('#promocode-form');
  if(promocodeForm) {
    formValidate(promocodeForm, promocodeSchema, async(body) => {
      const priceOrderItems = document.querySelectorAll('[data-price-order]');
      const deliveryPriceItem = document.querySelector('[data-price-order="delivery_price"]');
      const loyaltyInput = document.querySelector('#order-loyalty-input');

      if(!!loyaltyInput && !!loyaltyInput.value) {
        body.bonus_amount = Number(loyaltyInput.value);
      } else {
        body.bonus_amount = 0;
      };

      const input = promocodeForm.elements.promo_code;
      const button = promocodeForm.elements.button;

      body.delivery_price = Number(deliveryPriceItem.innerHTML.split(',').join('.'));
      const res = await sendData(body, `/api/order/${getCurrentQuery()[0]?.order_id}/prices/`)
        .then(res => {
          input.classList.add('success');
          button.disabled = true;
          if (typeof ym === 'function') {
              ym(82592749,'reachGoal','okpromo');
          }

          Object.entries(res).forEach(([key, value]) => {
            const priceOrderItem = document.querySelector(`[data-price-order="${key}"]`);
            priceOrderItem.innerHTML = value;
            if(key === 'total_promocode') priceOrderItem.classList.add('active');
          });
        })
        .catch(error => {
          const data = error.data?.error || error.data?.detail || "Неизвестная ошибка";
          console.error("Ошибка POST:", data);
          input.classList.add('error');
          button.disabled = true;
        });
    });
  }
  // # 1
  const vacancyForm = document.querySelector("#vacancy-form");
  if (vacancyForm) {
    formValidate(vacancyForm, vacancySchema, (body) => {
      const birthdayInput = vacancyForm.querySelector('[name="birthday"]');
      if (birthdayInput.value !== "")
        body.birthday = formatDate(birthdayInput.value);

      const cityInput = vacancyForm.querySelector('[name="city"]');
      if (cityInput.dataset.attr !== "")
        body.city = parseInt(cityInput.dataset.attr);
      sendData(body, "/api/job-feedback/").then((res) => {
        if (res.error) {
          dialogAnimate("error", res.error);
        } else {
          window.location.href = "/success/";
        }
      });
    });
  }
  const downloadCandidatesForm = document.querySelector("#download-candidates");
  if (downloadCandidatesForm) {
    downloadCandidatesForm.onsubmit = (e) => {
      e.preventDefault();
    };
    const createdAfter = downloadCandidatesForm.elements.created_at_after;
    const createdBefore = downloadCandidatesForm.elements.created_at_before;
    const button = downloadCandidatesForm.elements.button;
    button.addEventListener("click", () => {
      getFile(
        `/api/job-feedback/download-candidates/?created_at_after=${createdAfter.value}&created_at_before=${createdBefore.value}`
      ).then((res) => {
        const aElement = document.createElement("a");
        aElement.setAttribute("download", "Список кандидатов");
        const href = URL.createObjectURL(res);
        aElement.href = href;
        aElement.setAttribute("target", "_blank");
        aElement.click();
        URL.revokeObjectURL(href);
      });
    });
  }
  const refundForm = document.querySelector("#refund-form");
  if (refundForm) {
    formValidate(refundForm, refundSchema, (body) => {
      const selectTitle = refundForm.querySelector(".__select__title");
      body.reason = selectTitle.dataset.attr;

      const itemsArray = [];

      const items = refundForm.querySelectorAll(
        ".__select_products__product:checked"
      );
      const promises = Array.from(items).map((item) => {
        const itemObj = {};
        itemObj.product_id = parseInt(item.dataset.id);
        itemObj.quantity = 1;
        itemsArray.push(itemObj);
      });
      Promise.all(promises).then(() => {
        body.items = itemsArray;

        sendData(
          body,
          `/api/order/${refundForm.dataset.id}/make-order-refund/`
        ).then((res) => {
          if (res.error) {
            dialogAnimate("error", res.error);
          } else {
            closeAllModals();
            clearForm(refundForm);
            dialogAnimate("refund");
          }
        });
      });
    });
  }
  const addNewCardForm = document.querySelector("#add-new-card");
  if (addNewCardForm) {
    formValidate(addNewCardForm, addCardSchema, (body) => {
      handleBankCardSubmit(body);
    });
  }
}

function formValidate(form, schema, callBack, formData) {
  form.onsubmit = (e) => {
    e.preventDefault();
  };
  const button = form.elements.button;

  const inputs = Object.keys(getBody(form))
    .map((el) => form.elements[`${el}`])
    .filter(
      (el) =>
        el.type === "text" || el.type === "textarea" || el.type === "password"
    );
  inputs.forEach((el) => {
    el.oninput = (evt) => {
      el.classList.remove("error");

      const body = getBody(evt.target.form);
      validateParse({
        schema: schema,
        body,
      })
        .then((res) => {
          if (button) button.disabled = false;
          if (button && form.dataset.state && form.dataset.state == "disabled")
            button.disabled = true;
          inputs.forEach((el) => {
            el.classList.remove("error");
          });

          if (button)
            button.onclick = () => {
              const formDataBody = new FormData(form);
              if (callBack) formData ? callBack(formDataBody) : callBack(body);
            };
        })
        .catch((error) => {
          const errorString = error.toString();

          const parse = JSON.parse(
            `[${getTextInsideSquareBrackets(errorString)}]`
          );
					
          const nameErrorInput = parse.map((el) => el.path[0]);
					
          let input = [];
          for (const errorName of nameErrorInput) {
            input.push(form.elements[`${errorName}`]);
          }
          if (button) button.disabled = true;
					
          input.forEach((el) => {
            el?.classList.add("error");
          });
          if (button) button.onclick = () => {};
        });
    };
  });
}

async function validateParse(validateInfo) {
  try {
    validateInfo.schema.parse(validateInfo.body);


    
    console.log("Validation successful");
    if (typeof validateInfo?.callback == "function") validateInfo?.callback();
    return true;
  } catch (error) {
    if (error instanceof z.ZodError) {
      // console.error("Validation failed:", error.errors);
      throw new Error(JSON.stringify(error.errors));
    } else {
      // console.error("Unknown error", error);
    }
  }
}

function clearForm(form) {
  const inputs = Object.keys(getBody(form)).map((el) => form.elements[`${el}`]);

  const button = form.elements.button;

  inputs.forEach((elem) => {
    elem.value = "";
  });

  button.disabled = true;
}

// Специальная очистка формы добавления адреса с сохранением города
function clearAddressFormPreserveCity(form) {
  if (!form) return;
  
  const button = form.elements.button;
  const preservedCity = form.elements.city ? form.elements.city.value : '';
  
  // Очищаем только адресные поля
  if (form.elements.street) form.elements.street.value = '';
  if (form.elements.house) form.elements.house.value = '';
  if (form.elements.apartment) form.elements.apartment.value = '';
  
  const privateHouseCheckbox = form.querySelector('[name="private-house"]');
  if (privateHouseCheckbox) privateHouseCheckbox.checked = false;
  
  // Отключаем кнопку отправки
  if (button) button.disabled = true;
  
  // Восстанавливаем город и диспатчим событие для триггера зависящей логики
  if (form.elements.city && preservedCity) {
    form.elements.city.value = preservedCity;
    form.elements.city.dispatchEvent(new Event('input'));
  }
}

function getBody(form) {
  const formData = new FormData(form);
  const body = {};
  for (let [name, value] of formData.entries()) {
    body[name] = value;
  }
  return body;
}

function getQuery(query) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(query);
}

function confirmPhone() {
    const codeMenu = document.getElementById('confirm-phone-in-order');
    codeMenu.style.display = 'flex';
    codeMenu.querySelector('#code-form-login-phone').value = document.querySelector('#form-phone-number').value
    codeMenu.querySelector('#code-form-login-referral').value = document.querySelector('#referral_code_inp').value
    const codeInput = codeMenu.querySelector('[name="code"]');
    codeMenu.addEventListener('input', () =>{
        if(codeInput.value.length === 4) codeInput.form.elements.button.click();
    });

    countdown(60, codeMenu, '/api/authentication/get-code/');
}

function countdown(duration, menu, api) {
    const block = menu.querySelector('.__code_menu_timer');
    const restart = menu.querySelector('.__code_menu_reask');
    var timer = duration, minutes, seconds;
    sendCodeRequest()
    restart.classList.add('link_disabled');
    setTimer();
    restart.onclick = () =>{
        sendCodeRequest()
        restart.classList.add('link_disabled');
    };
    async function sendCodeRequest() {
        const body = {};
        const codeFormPhone = menu.querySelector('[name="phone"]');
        body.phone = codeFormPhone.value;
				const token = await getCaptchaV3Token();
				const bodyWithCaptcha = token ? { ...body, g_recaptcha_response: token } : body;
        sendData(bodyWithCaptcha, api);
    }
    function setTimer() {
        const timerInterval = setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            block.textContent = minutes + ":" + seconds;

            if(--timer < 0) {
                timer = duration;
                clearInterval(timerInterval);
                restart.classList.remove('link_disabled');
            }
        }, 1000);
    }
}

export function dialogAnimate(attr, text) {
  const dialog = document.querySelector(
    `.dialog-success[data-dialog="${attr}"]`
  );
  if (!dialog) return;
  dialog.dataset.state = "active";
  setTimeout(() => {
    dialog.dataset.state = "disabled";
  }, 5500);
  if (text) {
    const textBlock = dialog.querySelector(
      ".dialog-success__title-block__text"
    );
    textBlock.innerHTML = text;
  }
}

export function setCityDelivery() {
  const cityInputs = document.querySelectorAll('input[name="city"]');
  
  if (cityInputs.length === 0) return;
  
  // Кэш для хранения списка городов
  let citiesCache = null;
  
  // Функция для получения списка городов из API
  async function getCitiesFromShops() {
    if (citiesCache) return citiesCache;
    
    try {
      const response = await fetch('/api/shops/');
      const data = await response.json();
      
      // Извлекаем уникальные города из магазинов
      const cities = [...new Set(data.results.map(shop => shop.city))];
      citiesCache = cities;
      return cities;
    } catch (error) {
      console.error('Ошибка при получении списка городов:', error);
      return [];
    }
  }
  
  cityInputs.forEach(input => {
    // Создаем контейнер для списка городов если его нет
    let listContainer = input.closest('.field').querySelector('.address-menu__info-list__container');
    let list = input.closest('.field').querySelector('.address-menu__info-list');
    
    if (!listContainer) {
      listContainer = document.createElement('div');
      listContainer.className = 'address-menu__info-list__container custom-scrollbar';
      input.closest('.field').appendChild(listContainer);
    }
    
    if (!list) {
      list = document.createElement('div');
      list.className = 'address-menu__info-list __address_input__list';
      listContainer.appendChild(list);
    }
    
    // Добавляем обработчик события input
    input.addEventListener('input', debounce(async (e) => {
      const value = e.target.value.trim();
      
      if (value.length < 2) {
        list.dataset.state = 'disabled';
        list.innerHTML = '';
        return;
      }
      
      try {
        // Получаем список городов из API
        const cities = await getCitiesFromShops();
        
        // Фильтруем города по введенному тексту
        const filteredCities = cities.filter(city => 
          city.toLowerCase().includes(value.toLowerCase())
        );
        
        if (filteredCities.length === 0) {
          list.dataset.state = 'disabled';
          list.innerHTML = '';
          return;
        }
        
        // Создаем элементы списка
        const fragment = document.createDocumentFragment();
        filteredCities.forEach(city => {
          
          const inputOld = document.querySelector('#wholesalers-form-city-input')
          
          console.log(city)
          console.log()

          console.log(shopsData)

          const item = document.createElement('div');
          item.className = 'address-menu__info-list__item';
          item.textContent = city;
          
          item.addEventListener('click', () => {
            
            if (inputOld) {
              inputOld.value = city
            }
            
            console.log('=== НАЧАЛО ОБРАБОТКИ КЛИКА ПО ГОРОДУ ===');
            console.log('begin click');
            
            const input = document.querySelector('#find-city-modal')
            console.log('Найден input для города:', input);

            if (!input) {
                console.log('❌ Input не найден, прерываем выполнение');
                return;
            }

            console.log('✅ Input найден, заполняем значение:', city);
            input.value = city;
            console.log('Устанавливаем состояние списка в disabled');
            list.dataset.state = 'disabled';
            console.log('Очищаем содержимое списка');
            list.innerHTML = '';
            
            console.log('Убираем класс error с input');
            input.classList.remove('error');
            
            // Логика из cityMap.js
            console.log('Устанавливаем цвет текста в input');
            input.style.color = '#383838';
            
            // Находим город в списке городов
            const cities = shopsData.results
            console.log('Получен список городов:', cities.length, 'городов');
            const cityData = cities.find(cityItem => cityItem.city.trim() === city.trim());
            console.log('Найденные данные города:', cityData);
            
            if (cityData) {
                console.log('✅ Данные города найдены, обрабатываем координаты');
                const coordinates = parseCoordinates(cityData.coordinates);
                console.log('координаты ', coordinates);
                
                // Заполняем поля города
                console.log('Заполняем поля города');
                const cityInput = document.querySelector('#new-city-modal-input');
                const cityMap = document.querySelector('#city-map-modal-city');
                    const regionHiddenInput = document.querySelector('#new-region-modal-input');
                console.log('Найден cityInput:', cityInput);
                console.log('Найден cityMap:', cityMap);
                
                if (cityInput || cityMap) {
                    console.log('Устанавливаем значения в поля города:', cityData.city);
                    cityInput.value = cityData.city;
                    cityMap.value = cityData.city;
                        // Если есть скрытое поле региона — заполняем его из данных города (если доступно)
                        try {
                            if (regionHiddenInput) {
                                regionHiddenInput.value = cityData.region || '';
                            }
                        } catch (e) {}
                } else {
                    console.log('❌ Поля города не найдены');
                }
                
                // Разблокируем поле ввода улицы после выбора города
                try {
                    const addressMenus = document.querySelectorAll('.__address_input__menu[data-list="address"]');
                    addressMenus.forEach(menu => {
                        const addrInput = menu.querySelector('.__address_input__input');
                        if (addrInput) {
                            addrInput.classList.remove('disabled');
                            addrInput.value = '';
                            if (addrInput.form) {
                                addrInput.form.dataset.state = 'disabled';
                            }
                        }
                    });
                } catch (e) {}
                
                // Запускаем события
                console.log('Запускаем событие input');
                input.dispatchEvent(new Event('input'));
                
                // Вызываем функции CDEK и MHAND
                console.log('Проверяем наличие функций CDEK и MHAND');
                console.log('window.cdek существует:', !!window.cdek);
                console.log('window.mhand существует:', !!window.mhand);
                
                if (window.cdek && window.mhand) {
                    console.log('✅ Сбрасываем состояние доставки и вызываем CDEK/MHAND с координатами');
                    if (window.resetDeliveryState) {
                        try { window.resetDeliveryState(); } catch (e) {}
                    }
                    window.cdek(coordinates, { skipInitialSelect: true });
                    window.mhand(coordinates);
                } else {
                    console.log('❌ Функции CDEK или MHAND не найдены');
                }
                
                // Показываем методы доставки
                console.log('Ищем блок методов доставки');
                const deliveryMethods = document.querySelector('.order-section__card__delivery-list');
                console.log('Найден блок методов доставки:', deliveryMethods);
                
                if (deliveryMethods) {
                    console.log('✅ Показываем методы доставки');
                    deliveryMethods.style.display = 'grid';
                } else {
                    console.log('❌ Блок методов доставки не найден');
                }
                
                // Проверяем условия для самовывоза
                console.log('Проверяем наличие функции checkForDeliveryMhand');
                console.log('window.checkForDeliveryMhand существует:', !!window.checkForDeliveryMhand);
                
                if (window.checkForDeliveryMhand) {
                    console.log('✅ Вызываем checkForDeliveryMhand для города:', cityData.city);
                    window.checkForDeliveryMhand(cityData.city);
                } else {
                    console.log('❌ Функция checkForDeliveryMhand не найдена');
                }
                
                // Получаем цены доставки
                console.log('Проверяем наличие функции getData');
                console.log('window.getData существует:', !!window.getData);
                
                if (window.getData) {
                    console.log('✅ Запрашиваем цены доставки для города:', city);
                    window.getData(`/cdek-delivery/select-city?city=${city}`)
                        .then(res => {
                            console.log('Получены данные о ценах доставки:', res);
                            const price137 = document.querySelector('#price-137');
                            const price136 = document.querySelector('#price-136');
                            console.log('Найден price137:', price137);
                            console.log('Найден price136:', price136);
                            
                            if (price137) {
                                console.log('Устанавливаем цену для price137:', res[0].total_delivery_sum);
                                price137.textContent = `${res[0].total_delivery_sum} руб.`;
                            }
                            if (price136) {
                                console.log('Устанавливаем цену для price136:', res[1].total_delivery_sum);
                                price136.textContent = `${res[1].total_delivery_sum} руб.`;
                            }
                        })
                        .catch(error => {
                            console.error('❌ Ошибка при получении цен доставки:', error);
                        });
                } else {
                    console.log('❌ Функция getData не найдена');
                }

                list.style.display = 'none'
            } else {
                console.log('❌ Данные города не найдены в списке');
            }
            
            // Запускаем валидацию формы если она есть
            console.log('Ищем родительскую форму');
            const form = input.closest('form');
            console.log('Найдена форма:', form);
            console.log('Состояние формы:', form?.dataset.state);
            
            if (form && form.dataset.state !== 'disabled') {
                console.log('✅ Запускаем валидацию формы');
                const event = new Event('input', { bubbles: true });
                input.dispatchEvent(event);
            } else {
                console.log('❌ Форма не найдена или отключена');
            }
            
            // Обновляем dropdown CDEK при выборе города
            console.log('Проверяем наличие функции updateCdekDropdown');
            console.log('window.updateCdekDropdown существует:', !!window.updateCdekDropdown);
            
            if (window.updateCdekDropdown) {
                console.log('✅ Обновляем dropdown CDEK');
                window.updateCdekDropdown();
            } else {
                console.log('❌ Функция updateCdekDropdown не найдена');
            }
            
            console.log('=== КОНЕЦ ОБРАБОТКИ КЛИКА ПО ГОРОДУ ===');
          });
          
          fragment.appendChild(item);
        });
        
        list.innerHTML = '';
        list.appendChild(fragment);
        list.dataset.state = 'active';
        
      } catch (error) {
        console.error('Ошибка при получении списка городов:', error);
        list.dataset.state = 'disabled';
        list.innerHTML = '';
      }
    }, 300));
    
    // Скрываем список при клике вне input
    document.addEventListener('click', (e) => {
      if (!input.closest('.field').contains(e.target)) {
        list.dataset.state = 'disabled';
        list.innerHTML = '';
      }
    });
    
    // Скрываем список при потере фокуса
    input.addEventListener('blur', () => {
      setTimeout(() => {
        list.dataset.state = 'disabled';
        list.innerHTML = '';
      }, 200);
    });
  });
}

// Функция для парсинга координат
function parseCoordinates(coordinatesString) {
    if (!coordinatesString) return null;
    
    const coords = coordinatesString.replace(/\s/g, '').split(',');
    
    const latitude = parseFloat(coords[0]);
    const longitude = parseFloat(coords[1]);
    
    if (isNaN(latitude) || isNaN(longitude)) {
        return null;
    }
    
    return [latitude, longitude];
}
